import React, { useState } from 'react';
import { Loader2, ScanLine } from 'lucide-react';
import { IS_NATIVE } from '../../config/runtime';
import { scanCode } from '../../utils/nativeScan';

/**
 * A camera-scan button for the store app; renders nothing in a browser.
 * `onScan(text)` receives the barcode / QR text.
 */
export default function ScanButton({ onScan, className = '', label = 'Scan a barcode or QR code', size = 18 }) {
  const [busy, setBusy] = useState(false);
  if (!IS_NATIVE) return null;

  const run = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const text = await scanCode();
      if (text) onScan(text);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      title={label}
      aria-label={label}
      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-slate-600 hover:bg-slate-100 active:bg-slate-200 ${className}`}
    >
      {busy ? <Loader2 size={size} className="animate-spin" /> : <ScanLine size={size} />}
    </button>
  );
}
